import { sanitizeString } from '../../../../shared/helpers/sanitizeString';

export function searchShop<T extends { address: string; name: string }>(serchValue: string, shops: T[]): T[] {
  try {
    return shops.filter(
      shop =>
        sanitizeString(shop.address).includes(sanitizeString(serchValue)) || sanitizeString(shop.name).includes(sanitizeString(serchValue)),
    );
  } catch (error) {
    return shops;
  }
}
